// 풀 리로드 시 React 마운트 전 safe-area 색 (public/index.html 프리페인트
// 인라인 스크립트가 사용). index.html 은 번들 밖이라 import 할 수 없어 같은
// hex 를 하드코딩한다 — 어긋나면 prePaintColors.test.ts 가 실패하므로
// 값 변경 시 index.html 도 함께 갱신할 것.

// /product 및 온보딩 product step: 660_* 이미지 상·하단 가장자리 색
export const PRODUCT_SAFE_AREA_COLOR = "#1D2428";

// /promotion* 콜드 로드 기본색 (Background.Level1 hex, 정적 theme-color 와 동일).
// 스텝별 정확한 색은 마운트 후 useSafeAreaColor 가 즉시 덮어쓴다.
export const PROMOTION_PRE_PAINT_COLOR = "#F6F9FA";
